import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { StyleClass } from 'primeng/styleclass';
import { Ripple } from 'primeng/ripple';

@Component({
    selector: 'app-public-header',
    standalone: true,
    imports: [RouterModule, ButtonModule, StyleClass, Ripple],
    template: `
        <header class="flex items-center justify-between px-6 sm:px-12 lg:px-20 py-6 bg-surface-0 dark:bg-surface-900 shadow-sm">
            <!-- Logo -->
            <a [routerLink]="['/']" class="flex items-center gap-3 cursor-pointer">
                <img src="/images/apex/apex-logo.png" alt="Modern Apex" class="h-10 w-auto" />
                <span class="text-xl font-bold text-surface-900 dark:text-surface-0 hidden sm:inline">Modern Apex</span>
            </a>

            <!-- Desktop Navigation -->
            <nav class="hidden lg:flex items-center gap-2">
                <a
                    [routerLink]="['/']"
                    routerLinkActive="text-primary"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="px-4 py-2 font-semibold text-surface-700 dark:text-surface-200 hover:text-primary transition-colors duration-200"
                >
                    Home
                </a>
                <a
                    [routerLink]="['/services']"
                    routerLinkActive="text-primary"
                    class="px-4 py-2 font-semibold text-surface-700 dark:text-surface-200 hover:text-primary transition-colors duration-200"
                >
                    Services
                </a>
                <a
                    [routerLink]="['/contact']"
                    routerLinkActive="text-primary"
                    class="px-4 py-2 font-semibold text-surface-700 dark:text-surface-200 hover:text-primary transition-colors duration-200"
                >
                    Contact
                </a>
                <div class="w-px h-6 bg-surface-300 dark:bg-surface-600 mx-2"></div>
                <a [routerLink]="['/login']" class="px-4 py-2 font-semibold text-surface-700 dark:text-surface-200 hover:text-primary transition-colors duration-200">
                    Login
                </a>
                <a [routerLink]="['/register']">
                    <button pButton pRipple label="Register" class="p-button-primary"></button>
                </a>
            </nav>

            <!-- Mobile Menu Button -->
            <div class="relative lg:hidden">
                <button
                    pButton
                    pRipple
                    class="p-button-text p-button-rounded w-12 h-12"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveActiveClass="animate-fadeout"
                    leaveToClass="hidden"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-bars text-2xl"></i>
                </button>

                <!-- Mobile Menu Dropdown -->
                <div
                    class="hidden absolute right-0 top-full mt-2 z-50 w-56 bg-surface-0 dark:bg-surface-900 rounded-xl shadow-lg border border-surface-200 dark:border-surface-700 p-4"
                >
                    <ul class="flex flex-col gap-1 m-0 p-0 list-none">
                        <li>
                            <a
                                [routerLink]="['/']"
                                class="block px-4 py-3 rounded-lg font-semibold text-surface-700 dark:text-surface-200 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors"
                            >
                                Home
                            </a>
                        </li>
                        <li>
                            <a
                                [routerLink]="['/services']"
                                class="block px-4 py-3 rounded-lg font-semibold text-surface-700 dark:text-surface-200 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors"
                            >
                                Services
                            </a>
                        </li>
                        <li>
                            <a
                                [routerLink]="['/contact']"
                                class="block px-4 py-3 rounded-lg font-semibold text-surface-700 dark:text-surface-200 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors"
                            >
                                Contact
                            </a>
                        </li>
                        <li class="border-t border-surface-200 dark:border-surface-700 my-2"></li>
                        <li>
                            <a
                                [routerLink]="['/login']"
                                class="block px-4 py-3 rounded-lg font-semibold text-surface-700 dark:text-surface-200 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors"
                            >
                                Login
                            </a>
                        </li>
                        <li>
                            <a
                                [routerLink]="['/register']"
                                class="block px-4 py-3 rounded-lg font-semibold text-primary hover:bg-primary-50 dark:hover:bg-primary-900/20 transition-colors"
                            >
                                Register
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    `
})
export class PublicHeaderComponent {}
